"use strict";

var parse5 = require("parse5");

var treeAdapter = require("./parse5-adapter-serialization");

var NODE_TYPE = require("../living/node-type");

exports.domToHtml = function (iterable) {
  var ret = "";
  var _iteratorNormalCompletion = true;
  var _didIteratorError = false;
  var _iteratorError = undefined;

  try {
    for (var _iterator = iterable[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
      var node = _step.value;

      if (node.nodeType === NODE_TYPE.DOCUMENT_NODE) {
        ret += parse5.serialize(node, {
          treeAdapter: treeAdapter
        });
      } else {
        // TODO: maybe parse5 can give us a hook where it serializes the node itself too:
        // https://github.com/inikulin/parse5/issues/230
        ret += parse5.serialize({
          childNodesForSerializing: [node]
        }, {
          treeAdapter: treeAdapter
        });
      }
    }
  } catch (err) {
    _didIteratorError = true;
    _iteratorError = err;
  } finally {
    try {
      if (!_iteratorNormalCompletion && _iterator.return != null) {
        _iterator.return();
      }
    } finally {
      if (_didIteratorError) {
        throw _iteratorError;
      }
    }
  }

  return ret;
};